import { Component, Input, OnInit } from '@angular/core';
import { VariablesService } from '../../services/variables.service';
import { RegistrationService } from 'src/app/services/registration.service';
import { ControlContainer, NgForm } from '@angular/forms';
import * as _ from 'lodash';

@Component({
  selector: 'app-guest-variables',
  standalone: false,
  templateUrl: './guest-variables.component.html',
  styleUrl: './guest-variables.component.scss',
  viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class GuestVariablesComponent {
  @Input() guest: any;

  adaSeating;

  constructor(
    private variablesService: VariablesService,
    private registrationService: RegistrationService
  )
  {}

  ngOnInit(): void {
    this.adaSeating = this.registrationService.getVariable(
      this.guest,
      this.variablesService.VARIABLE.varAdaSeating.ID,
      {}
    );
  }
}
